/** @jsx jsx */
import { forwardRef } from "react"

import { jsx } from "@trueskin-web/theme"

import { useFormControl } from "./form-control"

const sizes = {
  lg: {
    height: "48px",
    px: 4,
  },
  md: {
    height: "40px",
    px: 3,
  },
}

const Input = forwardRef((props, ref) => {
  const {
    as: Comp = "input",
    size = "md",
    isReadOnly,
    isFullWidth = true,
    isDisabled,
    isInvalid,
    isRequired,
    hoverBorderColor,
    ...otherProps
  } = props
  const formControl = useFormControl(props)

  return (
    <Comp
      ref={ref}
      aria-invalid={formControl.isInvalid}
      readOnly={formControl.isReadOnly}
      aria-readonly={isReadOnly}
      disabled={formControl.isDisabled}
      aria-disabled={formControl.isDisabled}
      required={formControl.isRequired}
      aria-required={formControl.isRequired}
      sx={{
        display: "flex",
        alignItems: "center",
        width: isFullWidth ? "100%" : undefined,
        appearance: "none",
        outline: "none",
        fontFamily: "inherit",
        fontSize: 2,
        lineHeight: "body",
        border: "1px",
        borderRadius: 0,
        color: "inherit",
        bg: "transparent",
        transition: "all .1s ease-in",
        "&:hover": {
          borderColor: hoverBorderColor ? hoverBorderColor : "primary",
        },
        "&:focus": {
          zIndex: 1,
          borderColor: hoverBorderColor ? hoverBorderColor : "primary",
          boxShadow: (theme) =>
            `0 0 0 1px ${
              hoverBorderColor ? hoverBorderColor : theme.colors.primary
            }`,
        },
        "&:disabled, &:disabled:focus, &:disabled:hover": {
          borderColor: "inherit",
          color: "disabled",
          cursor: "not-allowed",
        },
        "&[aria-invalid=true]": {
          borderColor: "attention",
        },
        "&[aria-invalid=true]:focus": {
          boxShadow: (theme) => `0 0 0 1px ${theme.colors.attention}`,
        },
        ...sizes[size],
      }}
      {...otherProps}
    />
  )
})

export default Input
